
<label class="Radiobox" :class="{ 'isLarge': large }">
  <input :checked="value" class="Radiobox__input" type="radio" v-on="$listeners" @change="change" />
  <span class="Radiobox__virtualInput"></span>
  <span v-if="$slots.default" class="Radiobox__label">
    <slot />
  </span>
</label>
